import React, { Suspense, memo } from 'react';
import { TableSkeleton } from './SkeletonLoader';

interface LazyRouteProps {
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  fallback?: React.ReactNode;
  name?: string;
}

const defaultFallback = (name?: string) => (
  <div className="container mx-auto py-8">
    <div className="space-y-4">
      <div className="h-8 w-48 bg-muted animate-pulse rounded" />
      <TableSkeleton rows={10} columns={4} />
    </div>
  </div>
);

export const LazyRoute = memo<LazyRouteProps>(({ 
  component: Component, 
  fallback, 
  name 
}) => (
  <Suspense fallback={fallback || defaultFallback(name)}>
    <Component />
  </Suspense>
));

LazyRoute.displayName = 'LazyRoute';